
import React from "react";

const ImageRepositoryHeader = () => {
  return (
    <div className="mb-6">
      <h1 className="text-2xl font-bold">Image Repository</h1>
      <p className="text-gray-600 mt-2">
        Import and manage images from your Bubble.io site. You can upload images from external URLs, 
        add metadata, and easily copy HTML snippets for use in your blog posts.
      </p>
    </div>
  );
};

export default ImageRepositoryHeader;
